
      <template>
        <svg v-on="$listeners" xmlns="http://www.w3.org/2000/svg" width="200" height="200" class="icon" viewBox="0 0 1024 1024"><path d="M512 1008V815.8c203.6 0 361.6-201.8 283.4-416-28.6-79.2-92.2-142.8-171.6-171.4-214.2-77.6-416.2 79.8-416.2 283.4H16C16 187.4 329.8-65.6 670 40.6c148.4 46.6 267.2 164.8 313.2 313.2C1089.6 694.4 837.2 1008 512 1008zm.6-382.8H321.4v191.2h191.2V625.2zM321.4 816.4H174v147.2h147.4V816.4zM174 693.2H50.8v123.2H174V693.2z"/></svg>
      </template>
      <script>
      export default {
        name: 'VueSvg',
      }
      </script>
    